import {
  LiveFramesAndAvatarResponse,
  UsdToWebCoinRateResponse,
  UserAvatarsResponse,
  UserFramesResponse,
} from '@wwe-portal/entities/webcoin.type';
import { nestApiClient } from './api-client';

export const getLiveFramesAndAvatars = () => {
  return nestApiClient.get<LiveFramesAndAvatarResponse>(`/webShop/v2/live`);
};

export const getUsdToWebCoinRate = async () => {
  return nestApiClient.get<UsdToWebCoinRateResponse>(
    `/webShop/v2/usdToCoinRate`
  );
};

export const getAllUserAvatars = () => {
  return nestApiClient.get<UserAvatarsResponse>(`/user/v2/avatars`);
};

export const getAllUserFrames = () => {
  return nestApiClient.get<UserFramesResponse>(`/user/v2/frames`);
};
